import { request, post, get } from '@/plugins/requestU'

// 申请保函
export function getApplyZtb(data) {
  return post('/guarantee-service/v0.1/guarantee/guarantee/tg/applyZtb', data)
}
// 删除保函
export function getDeleteZtb(data) {
  return post('/guarantee-service/v0.1/guarantee/guarantee/tg/deleteZtb', data)
}
// 保函列表
export function getListZtb(data) {
  return post('/guarantee-service/v0.1/guarantee/guarantee/tg/list', data)
}
// 保函详情
export function getDetailZtb(data) {
  return post('/guarantee-service/v0.1/guarantee/guarantee/tg/detailZtb', data)
}
// 更新保函
export function getUpdateZtb(data) {
  return post('/guarantee-service/v0.1/guarantee/guarantee/tg/updateZtb', data)
}
// 保函支付
export function getZtbPay(data) {
  return post('/guarantee-service/v0.1/guarantee/order/top/pay', data)
}
// 保函申请状态
export function getListGuaranteeStatus(data) {
  return post(
    '/guarantee-service/v0.1/guarantee/guarantee/tg/listGuaranteeStatus',
    data
  )
}
// 新增发票抬头
export function getAddTitle(data) {
  return post('/guarantee-service/v0.1/guarantee/user/tit/create', data)
}
// 更新发票抬头
export function getTitleUpdate(data) {
  return post('/guarantee-service/v0.1/guarantee/user/tit/update', data)
}

// 删除发票抬头
export function getDelTitle(data) {
  return post('/guarantee-service/v0.1/guarantee/user/tit/delete', data)
}
// 发票抬头列表
export function getTitleList(data) {
  return post('/guarantee-service/v0.1/guarantee/user/tit/list', data)
}
// 发票抬头详情
export function getTitleDetail(data) {
  return post('/guarantee-service/v0.1/guarantee/user/tit/detail', data)
}
// 申请发票
export function getInvoiceAdd(data) {
  return post('/guarantee-service/v0.1/guarantee/invoice/ti/create', data)
}
// 申请发票详情
export function getInvoiceDetail(data) {
  return post('/guarantee-service/v0.1/guarantee/invoice/ti/detail', data)
}
// 申请发票列表
export function getInvoiceList(data) {
  return post('/guarantee-service/v0.1/guarantee/order/to/list', data)
}
export function getInvoiceListNew(data) {
  return post('/guarantee-service/v0.1/guarantee/invoice/ti/listKp', data)
}
// 申请发票状态
export function getInvoiceStatus(data) {
  return post(
    '/guarantee-service/v0.1/guarantee/invoice/ti/getInvoiceStatus',
    data
  )
}
// 钱款去向
export function getListRefundMoneyHis(data) {
  return post(
    '/guarantee-service/v0.1/guarantee/order/tro/listRefundMoneyHis',
    data
  )
}
// 上传付款凭证接口
export function getOrderTopPay(data) {
  return post('/guarantee-service/v0.1/guarantee/order/top/pay', data)
}
// 上传付款凭证接口
export function getaddSignFiles(data) {
  return post(
    '/guarantee-service/v0.1/guarantee/guarantee/tg/addSignFiles',
    data
  )
}
// 上传的付款凭证回显
export function getPayOrderApi(data) {
  return post('/guarantee-service/v0.1/guarantee/order/to/getPayOrder', data)
}
